// API timestamps are ISO strings; <input type="datetime-local"> wants local "YYYY-MM-DDTHH:mm".
export const toLocalInputValue = (value) => {
    if (!value) return '';
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return '';
    const offsetMs = date.getTimezoneOffset() * 60000;
    return new Date(date.getTime() - offsetMs).toISOString().slice(0, 16);
};

// Converts a datetime-local value back to ISO, or '' when empty (which clears the field server-side).
export const fromLocalInputValue = (value) => (value ? new Date(value).toISOString() : '');

// Today in the viewer's timezone, as <input type="date"> wants it ("YYYY-MM-DD").
export const todayInputValue = () => toLocalInputValue(new Date()).slice(0, 10);

// Starting point when someone picks the Custom period: the last 30 days.
export const defaultCustomRange = () => {
    const from = new Date();
    from.setDate(from.getDate() - 30);
    return { from: toLocalInputValue(from).slice(0, 10), to: todayInputValue() };
};

export const isCustomRangeValid = ({ from, to }) => Boolean(from && to && from <= to);
